import React, { useState } from "react";
import { useFirebaseDatabaseRootData } from "../../context/FirebaseDatabaseRootDataContext";
import CircularImage from "../Utils/CircularImage";
import ContactPopover from "./ContactPopover"; // Import the new component
import "./Info.css";

const Info = () => {
  const { rootData, rootDataLoading, rootDataError } =
    useFirebaseDatabaseRootData();
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  if (rootDataLoading) {
    return (
      <div className="info-container">
        <div className="info-loading">Loading about information...</div>
      </div>
    );
  }

  if (rootDataError) {
    return (
      <div className="info-container">
        <div className="info-error">
          Error loading about information: {rootDataError}. Please try again
          later.
        </div>
      </div>
    );
  }

  if (!rootData || !rootData.about || !rootData.about.description) {
    return (
      <div className="info-container">
        <div className="info-no-data">
          About information not found or incomplete.
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="info-container">
        <div className="info-page-empty-container"></div>
        <div className="about-div">
          <div className="about-content">
            <CircularImage
              src="https://i.ibb.co/LznTjvpC/PXL-20250611-104003097.jpg"
              size={300}
            />
            <p className="about-paragraph">{rootData.about.description}</p>
            
            <div className="info-contact-button-container">
            <button
              className="info-contact-button"
              onClick={() => setIsPopoverVisible(true)}
            >
              <span className="arrow-icon">→</span>say hi
            </button>
            </div>

          </div>
        </div>
        <div className="info-page-empty-container"></div>
      </div>

      {isPopoverVisible && (
        <ContactPopover onClose={() => setIsPopoverVisible(false)} />
      )}
    </>
  );
};

export default Info;
